import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseB2BOffers() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      description: isEmpty(state.description),
      totalCost: isEmpty(state.totalCost),
      offerPercent: isEmpty(state.offerPercent),
    };

    setter(errorState);

    if (
      errorState.description ||
      errorState.totalCost ||
      errorState.offerPercent
    ) {
      enqueueSnackbar("لطفا اطلاعات آفر را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getOffersList = (callback) => {
    MyAxios.get(`Admin_Marketing_B2BOrders/offers`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getOfferByID = (id, callback) => {
    MyAxios.get(`Admin_Marketing_B2BOrders/offers/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updateOffer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Marketing_B2BOrders/offers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addOffer = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    MyAxios.post(`Admin_Marketing_B2BOrders/offers`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar(" با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteOffer = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Marketing_B2BOrders/offers`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    getOffersList,
    getOfferByID,
    validate,
    updateOffer,
    addOffer,
    deleteOffer,
  };
}
